import { Message } from '@/src/elements/message'
import { PlaceholderLine } from '@/src/elements/placeholder'
import { Typography } from '@/src/elements/text/Typography'
import type { TPublicationApi } from '@/src/features/publication/api/types/getPublication.types'
import { TEST_ID } from '@/src/general/constants/testId'
import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

export const PublicationRewardSuccessDetails = ({
  isError,
  publication,
}: {
  isError: boolean
  publication?: Pick<TPublicationApi, 'prayersCount'>
}) => {
  const { t } = useTranslate()

  if (isError)
    return (
      <Message colors="danger" iconName={ICON.ALERT_TRIANGLE} testID={TEST_ID.PUBLICATION.REWARD.SCREEN.ERROR}>
        {t('publication.load.error')}
      </Message>
    )
  if (!publication) return <PlaceholderLine testID={TEST_ID.PUBLICATION.REWARD.SCREEN.LOADING} />
  if (publication.prayersCount && publication.prayersCount > 0)
    return <Typography>{t('publication.prayed', { count: publication.prayersCount })}</Typography>
  return null
}
